import * as React from "react";
const SvgFiBrandsAppStoreIos = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-app-store-ios_svg__a)">
      <path
        fill="#151A2D"
        d="M19.947.001H5.049C2.259.001 0 2.17 0 4.849v14.305c0 2.676 2.26 4.845 5.049 4.845H19.95c2.788 0 5.049-2.169 5.049-4.847V4.849C24.997 2.17 22.738.001 19.947.001m-13.036 19c-.312.525-1.009.702-1.556.402a1.07 1.07 0 0 1-.419-1.494l.813-1.35c.919-.273 1.665-.063 2.256.621zm7.9-2.945H4.468c-.632 0-1.138-.486-1.138-1.092s.506-1.092 1.138-1.092h2.899l3.712-6.176-1.16-1.932c-.312-.525-.127-1.188.42-1.494a1.167 1.167 0 0 1 1.556.402l.497.843.506-.84c.313-.525 1.01-.702 1.556-.402.547.3.732.969.419 1.493l-4.877 8.105h3.528c1.142.001 1.782 1.291 1.285 2.185m5.571.006h-1.644l1.11 1.847c.312.525.128 1.188-.419 1.494-.547.3-1.237.123-1.556-.402-1.868-3.111-3.272-5.438-4.202-6.989-.953-1.578-.272-3.162.4-3.699q1.119 1.846 3.352 5.565h2.96c.63 0 1.137.486 1.137 1.092-.001.606-.506 1.092-1.138 1.092"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-app-store-ios_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsAppStoreIos;
